export default "__VITE_ASSET__3f76ada9__"